import React from 'react'

const RenderRawHTML = (htmlInput, options) => {
    const createMarkup = htmlString => ({ __html: htmlString });
    const opts = options || {};
    const usePTag = opts.usePTag || false;
    const cssClass = opts.className || null;

    if (usePTag) {
        return (
            <p className={cssClass} dangerouslySetInnerHTML={createMarkup(htmlInput)} />
        )
    }

    return (
        <div className={cssClass} dangerouslySetInnerHTML={createMarkup(htmlInput)} />
    )
}

export default RenderRawHTML;